import {NgModule} from '@angular/core';
import {WbpComponent} from './components/wbp/wbp.component';
import {WebModule} from '../../components/web/web.module';
import {MobilModule} from '../../components/mobil/mobil.module';
import {SeitenleisteModule} from '../obs.seitenleiste/seitenleiste.module';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import {ServicesModule} from '../../services/services.module';
import {PipeModule} from '../../pipe/pipe.module';
import {MaterialModule} from './material.module';
import {SharedModule} from '../obs.shared/shared.module';
import {RegistrierungModule} from '../obs.registrierung/component/registrierung.module';
import {SpeiseplanModule} from '../obs.speiseplan/speiseplan.module';
import {WbaComponent} from './components/wba/wba.component';
import {ShellModule} from '../obs.shell/shell.module';

@NgModule({
  imports: [
    WebModule,
    MobilModule,
    SeitenleisteModule,
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule,
    ServicesModule,
    PipeModule,
    MaterialModule,
    SharedModule,
    RegistrierungModule,
    SeitenleisteModule,
    SpeiseplanModule,
    ShellModule,
  ],
  declarations: [
    WbpComponent,
    WbaComponent
  ],
  exports: [
    WbpComponent,
    WbaComponent
  ],
})
export class CoreModule {}
